/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Schema for analysis header
 */
export interface AnalysisHeader { 
    /**
     * Sort order of the column in the table
     */
    sort?: number;
    /**
     * Title of the column
     */
    columnTitle?: string;
    /**
     * Data type of the column used for sorting
     */
    sortType?: string;
    /**
     * Sort order indicator (1 for ascending, -1 for descending)
     */
    sortOrder?: number;
}

